import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const ArrowLeft: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M9.7 10.3a1 1 0 0 1 0 1.4L6.42 15H28a1 1 0 1 1 0 2H6.41l3.3 3.3a1 1 0 0 1-1.42 1.4l-5-5a1 1 0 0 1 0-1.4l5-5a1 1 0 0 1 1.42 0Z"
    />
  </Icon>
);
